import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/GeneralComponents/Button";
import DomeCareTitle from "../../components/GeneralComponents/DomeCareTitle";
import { handleSetGetStartedActivated } from "../../redux/slices/orderSessionStorage";
import { handleIsPreventUserNavigation } from "../../redux/slices/orderSlice";
import { RootState } from "../../redux/store";
import { clearLocalStorageExceptReduxPersist } from "../../utils/Functions";
import { BASE_LOCAL_IMAGES_DIR } from "../../utils/constants/CommonConstants";
import { error404Avatar_IMG } from "../../utils/constants/Images";

const ErrorPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, isAuthenticated, role } = useSelector(
    (state: RootState) => state.auth,
  );

  // ?=======================Back To Home Page =================
  const handleBackToHomePage = () => {
    if (user?.token && isAuthenticated && role !== undefined && role !== null) {
      navigate("/", { replace: true });
    } else {
      navigate("/auth/login", { replace: true });
    }
    clearLocalStorageExceptReduxPersist();
    dispatch(handleIsPreventUserNavigation(false));
    dispatch(handleSetGetStartedActivated(false));
  };

  return (
    <section className="relative flex min-h-screen flex-col items-center justify-center">
      <div className="absolute left-10 top-10">
        {/* <DomeCareTitle imageClassName={"!w-full"} /> */}
      </div>
      <div className="flex flex-col gap-4">
        <img
          src={`${BASE_LOCAL_IMAGES_DIR}/${error404Avatar_IMG}`}
          alt="avatar"
          loading="lazy"
          className="mx-auto max-w-96"
        />
        <div className="flex flex-col gap-10">
          <div className="flex flex-col items-center gap-1">
            <h1 className="text-2xl font-bold text-headingTextColor">
              {t("sorry_page_not_found")}
            </h1>
            <p className="w-2/5 text-center text-base font-normal text-textColor">
              {t("sorry_page_not_found_desc")}
            </p>
          </div>
          <Button
            variant="primary"
            title={t("go_to_home")}
            extraClassName="!w-fit mx-auto !font-normal !px-3"
            onClick={() => handleBackToHomePage()}
          />
        </div>
      </div>
    </section>
  );
};

export default ErrorPage;
